<template>
  <b-card>
   <h3>{{$t('MY_ACCOUNT.Config_Title')}}</h3>
    <!-- form -->
    <b-form class="form-user">
      <b-row>
        <b-col sm="12">
          <h5>{{$t('MY_ACCOUNT.Config_Change_Language')}}</h5>
          <flags></flags>
        </b-col>
        <b-col sm="12">
        <hr>
        </b-col>
        <b-col sm="12">
          <b-form-group :label="$t('MY_ACCOUNT.Config_Country')" label-for="country-list">
            <v-select
              id="country-list"
              v-model="form.country"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :options="country"
              :reduce="option => option.id"
            >
              <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            size="sm"
            @click="onSubmit"
          >
            {{$t('MY_ACCOUNT.Save')}}
          </b-button>
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            type="reset"
            class="mt-2"
            @click.prevent="resetForm"
          >
            Reset
          </b-button> -->
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BCard,
  // BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import vSelect from "vue-select";
import dropdownService from "@/providers/dropdownService";
import userService from "@/providers/userService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import localStorageHelper from '@/helpers/local-storage-helper';
import Flags from '@/views/components/Flags.vue';

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    vSelect,
    // BBadge,
    Flags,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      country: [],
      form: {
        _id: "",
        country: null,
      },
    };
  },
  created() {
    this.loadData();
  },
  watch: {
  },
  methods: {
    onSubmit() {
      userService
        .updateMyAccountConfig(this.form, new URLSearchParams())
        .then((data) => {
          console.log(data);
          messagesNotifyHelper.updatedRecordNotify();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      Promise.all([
        dropdownService.getAllCountries(new URLSearchParams()),
      ])
        .then((res) => {
          this.country = res[0];

          this.getUserDetail();
        })
        .catch((err) => console.log(err));
    },
    getUserDetail() {
      const params = new URLSearchParams();
      // console.log('state current user: ',this.$store.state.auth.currentUser)
      // params.append("email", this.$store.state.auth.currentUser.email);
      userService
        .getUserDetails(localStorageHelper.getUserId(), params)
        .then((res) => {
          this.form._id = res._id;
          this.form.country = res.country;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetForm() {
      // this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    },
  },
  setup() {
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>
